import { render, staticRenderFns } from "./optionDashboard.vue?vue&type=template&id=3bbead17"
import script from "./optionDashboard.vue?vue&type=script&lang=js"
export * from "./optionDashboard.vue?vue&type=script&lang=js"
import style0 from "./optionDashboard.vue?vue&type=style&index=0&id=3bbead17&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports